import useChatStore from 'Components/Chat/store';
import { get } from 'lodash';
import ModelsIcon from 'Theme/icons/modelsIcon';
import { icons as modelIcons } from 'Theme/icons/modelsIcons/index';

const DEFAULT_ICON_SIZE = 'h-10 w-10';
const DEFAULT_ICON = (
  <ModelsIcon className={DEFAULT_ICON_SIZE} stroke-cool-gray />
);

const getCurrentModel = (item, modelSelected) => {
  if (!Array.isArray(item)) {
    return item;
  }
  return modelSelected
    ? item.find((e) => e.modelRef === modelSelected)
    : item.find((e) => e.selected);
};

const getDallE3Icon = (modelsList) => {
  const gptIcon = modelsList.find((m) => m.model === 'gpt-4o-2024-08-06');
  const GptIconComponent = gptIcon?.icon ? get(modelIcons, gptIcon.icon) : null;

  return GptIconComponent ? (
    <GptIconComponent className={DEFAULT_ICON_SIZE} />
  ) : (
    DEFAULT_ICON
  );
};

const getModelIcons = (currentModel, modelsList) => {
  if (!currentModel) return [];

  if (Array.isArray(currentModel.modelRef)) {
    return currentModel.modelRef
      .map((ref) => {
        const icon = modelsList.find((m) => m._id === ref);
        return icon?.icon ? get(modelIcons, icon.icon) : null;
      })
      .filter(Boolean);
  }

  const icon = modelsList.find((m) => m._id === currentModel.modelRef);
  return icon?.icon ? [get(modelIcons, icon.icon)] : [];
};

const IconMessage = ({ message: item, modelSelected }) => {
  const modelsList = useChatStore((state) => state.modelsList);

  const getModelIcon = () => {
    const currentModel = getCurrentModel(item, modelSelected);

    if (currentModel?.model === 'Dall-E 3') {
      return getDallE3Icon(modelsList);
    }

    const icons = getModelIcons(currentModel, modelsList);

    if (icons.length === 0) {
      return DEFAULT_ICON;
    }

    return (
      <div className="flex flex-col gap-2">
        {icons.map((Icon, index) => (
          <Icon key={index} className={DEFAULT_ICON_SIZE} />
        ))}
      </div>
    );
  };

  return (
    <div className="w-fit h-full flex items-start justify-start">
      {getModelIcon()}
    </div>
  );
};

export default IconMessage;
